<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getTutor_conditions(to.params.id)
    })
  },
  methods: {
    getTutor_conditions (id) {
      this.$store.dispatch('getTutor_conditions', id)
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Tutor_conditions.vue?2e5fd8f2